import { unitChildTemplate, unitTemplate } from '@/components/RentAdjustment/Store';
import Vue from 'vue';

const state = {
    transferAllUnits: false,
    depositTransfer: null,
    reasonNoDepositTransfer: '',
    units: [],
    targetUnitOptions: [],
}

const mutations = {
    // Step 2 Mutations
    SET_TRANSFER_ALL_UNITS(state, value) {
        state.transferAllUnits = !state.transferAllUnits;
        let newUnits = state.units
        if (state.transferAllUnits) {
            let targetUnitIndex = 0;
            newUnits = state.units.map((unit, index) => {
                if (unit.isAllUnitUnavailable) return unit
                unit.selected = true;
                const newTargetUnit = state.targetUnitOptions[targetUnitIndex].value || { orderId: 0, orderCode: '', batch: 0, isNew: false }
                unit.targetUnit = newTargetUnit;
                const children = unit.children.map((child) => {
                    if (child.errMessage) {
                        child.selected = false;
                        child.targetUnit = { orderId: 0, orderCode: '', batch: 0, isNew: false }
                    } else {
                        child.selected = true;
                        child.targetUnit = newTargetUnit;
                    }
                    return child;
                })
                unit.children = children
                targetUnitIndex++;
                return unit
            });
        } else {
            newUnits = state.units.map((unit) => {
                if (unit.isAllUnitUnavailable) return unit
                unit.selected = false;
                unit.targetUnit = {
                    orderId: 0,
                    orderCode: '',
                    batch: 0,
                    isNew: false
                }
                const children = unit.children.map((child) => {
                    child.selected = false;
                    child.targetUnit = { orderId: 0, orderCode: '', batch: 0, isNew: false }
                    return child;
                })
                unit.children = children
                return unit
            });
        }

        state.units = newUnits
    },
    RESET_TRANSFER_ALL_UNITS(state) {
        state.transferAllUnits = false
    },
    SET_DEPOSIT_TRANSFER(state, value) {
        state.depositTransfer = value;
    },
    SET_REASON_NO_DEPOSIT_TRANSFER(state, value) {
        state.reasonNoDepositTransfer = value;
    },
    SET_ALL_UNIT_RENTING(state, value) {
        state.units = value;
    },
    SET_UNIT_FIELD(state, { index, field, value }) {
        if (state.units[index]) {
            state.units[index][field] = value;
            if (field === 'selected') {
                if (!value) {
                    state.units[index].targetUnit = { orderId: 0, orderCode: '', batch: 0, isNew: false };
                }
                state.units[index].children = state.units[index].children.map((child) => {
                    if (child.errMessage) return child
                    child.selected = value;
                    if (!value) {
                        child.targetUnit = { orderId: 0, orderCode: '', batch: 0, isNew: false };
                    }
                    return child;
                });
            } else {
                state.units[index].children = state.units[index].children.map((child) => {
                    if (child.errMessage) return child
                    child[field] = value;
                    child.selected = true;
                    return child;
                });
            }
        }
    },
    SET_CHILD_UNIT_FIELD(state, { unitIndex, childIndex, field, value }) {
        if (state.units[unitIndex] && state.units[unitIndex].children[childIndex]) {
            state.units[unitIndex].children[childIndex][field] = value;
            if (field === 'selected') {
                if (!value) {
                    state.units[unitIndex].children[childIndex].targetUnit = { orderId: 0, orderCode: '', batch: 0, isNew: false };
                    const anySelectedChild = state.units[unitIndex].children.some((child) => child.selected);
                    if (!anySelectedChild) {
                        state.units[unitIndex].selected = false;
                        state.units[unitIndex].targetUnit = { orderId: 0, orderCode: '', batch: 0, isNew: false };
                    }
                } else {
                    state.units[unitIndex].selected = true;
                }
            }
        }
    },
    UPDATE_UNIT(state, { index, data }) {
        if (state.units[index]) {
            state.units[index] = { ...state.units[index], ...data };
        }
    },
    TOGGLE_UNIT_SELECTED(state, value) {
        state.units = state.units.map((unit) => {
            if (unit.isAllUnitUnavailable) return unit
            unit.selected = value;
            if (!value) {
                unit.targetUnit = { orderId: 0, orderCode: '', batch: 0, isNew: false };
            }
            const children = unit.children.map((child) => {
                if (child.errMessage) return child
                child.selected = value;
                if (!value) {
                    child.targetUnit = { orderId: 0, orderCode: '', batch: 0, isNew: false };
                }
                return child;
            })
            unit.children = children
            return unit
        });
    },
    TOGGLE_UNIT_EXPANDED(state, index) {
        if (state.units[index]) {
            state.units[index].expanded = !state.units[index].expanded;
        }
    },
    TOGGLE_CHILD_UNIT_SELECTED(state, { unitIndex, childIndex }) {
        if (state.units[unitIndex] && state.units[unitIndex].children[childIndex]) {
            state.units[unitIndex].children[childIndex].selected =
                !state.units[unitIndex].children[childIndex].selected;
        }
    },
    RESET_UNITS(state) {
        let newUnits = state.units
        if (state.units && state.units.length > 0) {
            let newUnits = state.units.map((unit) => {
                const children = unit.children.map((child) => {
                    child.selected = false;
                    child.targetUnit = {
                        orderId: 0,
                        orderCode: '',
                        batch: 0,
                        isNew: false
                    }
                    return child;
                })
                unit.children = children
                unit.selected = false;
                unit.targetUnit = {
                    orderId: 0,
                    orderCode: '',
                    batch: 0,
                    isNew: false
                }
                return unit
            });
        }

        state.units = newUnits
    },
    SET_TARGET_UNIT_OPTIONS(state, value) {
        state.targetUnitOptions = value;
    },
    SET_EXISTING_UNIT(state, value) {
        state.existingUnit = value
    },
}

const actions = {
    async getLesseeOrderRenting({ commit, state }) {
        const { companyIdTarget, companyIdOriginal } = state
        if (!companyIdTarget || !companyIdOriginal) return
        commit('SET_LOADING', true);
        commit('SET_TARGET_UNIT_OPTIONS', []);
        commit('SET_ALL_UNIT_RENTING', []);
        commit('RESET_TRANSFER_ALL_UNITS');
        try {
            const response = await Vue.prototype.$http.post(process.env.GET_LESSEE_ORDER_RENTING, {
                ltId: state.id,
                companyIdOriginal: companyIdOriginal || 0,
                companyIdTarget: companyIdTarget || 0
            }, {
                headers: { 'Asani-Token': localStorage.getItem('jwt') }
            });
            const { listOrderRenting, listNewOrder } = response.data.content;

            // Parse target unit options for select input, this is used for child unit target unit selection
            const targetUnitOptions = listNewOrder.map((item) => {
                const value = {
                    isNew: true,
                    orderCode: item.newOrderCode,
                    batch: item.newBatch,
                    orderId: item.newOrderId
                }
                return {
                    value,
                    label: value
                }
            })

            // Parse Unit Data based on the response from API, this is used for unit selection in step 2
            // Also all order id/code will be used for target unit options as well
            const unitData = []
            listOrderRenting.forEach((item) => {
                const children = []
                item.items.map((child) => {
                    const newChild = { ...unitChildTemplate }
                    const keys = Object.keys(unitChildTemplate)
                    keys.forEach((key) => {
                        newChild[key] = child[key] || newChild[key]
                    })
                    children.push(newChild)
                })
                const newUnit = { ...unitTemplate }
                const keys = Object.keys(unitTemplate)
                keys.forEach((key) => {
                    newUnit[key] = item[key] || newUnit[key]
                })

                // Validate if all children have error, some children have error, or no children have error
                newUnit.errMessage = "Terdapat beberapa unit yang tidak bisa dialihkan. Buka rows untuk lihat detail."
                const isAllChildrenError = children.every((child) => child.errMessage.length > 0)
                const isSomeChildrenError = children.some((child) => child.errMessage.length > 0)
                if (isAllChildrenError) {
                    newUnit.isAllUnitUnavailable = true
                }
                if (isSomeChildrenError && !isAllChildrenError) {
                    newUnit.isAllUnitUnavailable = false
                }
                if (!isSomeChildrenError) {
                    newUnit.isAllUnitUnavailable = null
                    newUnit.errMessage = ""
                }

                newUnit.children = children
                newUnit.startRent = children[0].startRent
                newUnit.endRent = children[0].endRent
                unitData.push(newUnit)
            })

            // Set target unit options and unit data to the state
            commit('SET_TARGET_UNIT_OPTIONS', targetUnitOptions);
            commit('SET_ALL_UNIT_RENTING', unitData);
        } catch (error) {
            const errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message
                : 'An error occurred while fetching unit renting data.';
            return {
                isSuccess: false,
                message: errorMessage
            };
        } finally {
            commit('SET_LOADING', false);
        }
    },
    updateUnitField({ commit }, { index, field, value }) {
        commit('SET_UNIT_FIELD', { index, field, value });
    },
    toggleChildUnitSelected({ commit }, { unitIndex, childIndex }) {
        commit('TOGGLE_CHILD_UNIT_SELECTED', { unitIndex, childIndex });
    },
}

const getters = {
    getTransferAllUnits: (state) => state.transferAllUnits,
    getDepositTransfer: (state) => state.depositTransfer,
    getUnits: (state) => state.units,
    getUnit: (state) => (index) => state.units[index],
    getChildUnits: (state) => (index) => state.units[index] ? state.units[index].children || [] : [],
    getAllUnitsSelected: (state) => state.units.every((unit) => unit.selected),
    getTargetUnitOptions: (state) => state.targetUnitOptions,
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/components/RentAdjustment/FormTabs/Detail/DetailFormStep/ChooseUnit/store.js